export class FileList {
  id: string;
  name: string;
  created_at: string;
  docs: Doc[];
  status: number;
  updated_at: string;
};

export class Doc {
id: number;
name: string;
doclist_id: number;
description: string;
type: number;
status: number;
created_at: string;
updated_at: string;
};

export class Pagination {
total: number;
pages: number;
pageCount: number;
}

export class PaginatedDocList {
pagination: Pagination;
docs: Doc[];
}


// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/models/file.ts